import React from 'react';
import { motion, useScroll } from 'framer-motion';

const ScrollProgress: React.FC = () => {
  const { scrollYProgress } = useScroll();

  return (
    <div className="nav-scroll-progress-track" aria-hidden="true">
      <motion.div
        className="nav-scroll-progress-fill"
        style={{ scaleX: scrollYProgress }}
      />
    </div>
  );
};

export default ScrollProgress;
